import React from 'react'
import { TooltipProps } from 'recharts'
import { AnyToken } from 'src/common/types/models/Tokens'
import { displayAmount } from 'src/common/utils/formatters/number'
import { DataItem } from '../types'
import { getTooltipRangeData } from '../utils'

// Custom Tooltip component
interface MarketDepthChartTooltipProps extends TooltipProps<number, string> {
  data: DataItem[]
  buyToken: AnyToken
  sellToken: AnyToken
}

const _displayAmount = (amount?: number) =>
  amount && displayAmount(amount, { maxDecimals: 4, minThreshold: 0.0001 })

const MarketDepthChartTooltip: React.FC<MarketDepthChartTooltipProps> = ({
  active,
  payload,
  label,
  data,
  buyToken,
  sellToken,
}) => {
  const showTooltip = payload?.filter(Boolean).length && data[label]?.price

  const { rangeAmount, rangePrice } = getTooltipRangeData(data, label)

  if (active && payload && payload.length && showTooltip) {
    return (
      <div className='bg-black/75 rounded-lg p-1 text-white shadow-md'>
        <p className='m-0 typo-label1'>{`Avg. price: ${_displayAmount(
          rangePrice
        )} ${sellToken.symbol}/${buyToken.symbol}`}</p>
        <p className='m-0 typo-label1 '>
          Total amount: {_displayAmount(rangeAmount)} {buyToken.symbol}
        </p>
      </div>
    )
  }
  return null
}

export default MarketDepthChartTooltip
